import React from 'react';
import { NavLink, useNavigate } from 'react-router';
import './Footer.css';
import useBranding from '../../../hooks/useBranding';

const Footer = () => {
    const navigate = useNavigate();
    const branding = useBranding();

    const handleClick = (e) => {
        e.preventDefault();
        navigate("/");
        setTimeout(() => {
            const element = document.getElementById('revolution_sec_new');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <div className='footer-section' id="footer-section">
            <div className='footer-wraper'>
                <div className='footer-link-folder'>
                    <div className='footer-logo'>
                        {/* <img src={branding.logo} alt={branding.fullName} onClick={() => navigate("/")} /> */}
                    </div>
                    <p>{branding.fullName}</p>
                </div>
                <div className="footer-Quick-Links-folder">
                    <h2>Quick Links</h2>
                    <ul className="footer-Quick-Links">
                        <li>
                            <a href="revolution_sec_new" onClick={handleClick}>Features</a>
                        </li>
                        <li>
                            <NavLink to="/about">About Us</NavLink>
                        </li>
                        <li>
                            <NavLink to="/privacy-policy">Privacy Policy</NavLink>
                        </li>
                        {/* Terms & Conditions exists for ProSchool only; the route is not registered on SRDS. */}
                        {branding.variant !== "srds" && (
                            <li>
                                <NavLink to="/terms-and-conditions">Terms & Conditions</NavLink>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="footer-Quick-Links-folder">
                    <h2>Contact</h2>
                    <div className="footer-contact">
                        {branding.phone && (
                            <div className="footer-contact-folder">
                                <a><i className="fa-solid fa-phone"></i></a>
                                <span><a href={`tel:${branding.phoneTel || branding.phone}`}>{branding.phone}</a></span>
                            </div>
                        )}
                        {branding.contactEmail && (
                            <div className="footer-contact-folder">
                                <a><i className="fa-solid fa-envelope"></i></a>
                                <a href={`mailto:${branding.contactEmail}`}>{branding.contactEmail}</a>
                            </div>
                        )}
                        {branding.address && (
                            <div className="footer-contact-folder">
                                <a><i className="fa-solid fa-location-dot"></i></a>
                                <a href={branding.addressUrl || '#'} target="_blank" rel="noreferrer">
                                    {branding.address}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
                <div className='footer-Quick-Links-folder'>
                    <h2>Get in touch</h2>
                    <div className='footer-social-link-folder'>
                        {branding.social?.facebook && (
                            <a href={branding.social.facebook} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-facebook"></i>
                            </a>
                        )}
                        {branding.social?.twitter && (
                            <a href={branding.social.twitter} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-x-twitter"></i>
                            </a>
                        )}
                        {branding.social?.instagram && (
                            <a href={branding.social.instagram} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-instagram"></i>
                            </a>
                        )}
                        {branding.social?.vimeo && (
                            <a href={branding.social.vimeo} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-vimeo-v"></i>
                            </a>
                        )}
                        {branding.social?.linkedin && (
                            <a href={branding.social.linkedin} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-linkedin"></i>
                            </a>
                        )}
                        {branding.social?.youtube && (
                            <a href={branding.social.youtube} target="_blank" rel="noreferrer">
                                <i className="fa-brands fa-youtube"></i>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
